

































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { DataTableHeader } from 'vuetify'
import { FindImportacaoUseCase } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import {
	interpretarXmlsNaoGerados,
	ResumoDeXmlsNaoGerados,
	resumoVazio,
	XmlNaoGerado,
} from '@/shareds/xmls-nao-gerados'

type LinhaDeXmlNaoGerado = XmlNaoGerado & { indice: number }

@Component
export default class DialogoDeXmlsNaoGerados extends Vue {
	@Prop({ type: Function, required: true }) baixar!: (importacaoId: string) => Promise<void>

	mostra = false
	buscando = false
	baixando = false
	falhouAoBuscar = false
	importacaoId = ''
	origem = ''
	pagina = 1
	itensPorPagina = 10
	resumo: ResumoDeXmlsNaoGerados = resumoVazio()
	findImportacaoUseCase = new FindImportacaoUseCase()
	buscaAtual = 0

	headers: DataTableHeader[] = [
		{ text: 'Documento', value: 'tipo', width: '140px' },
		{ text: 'Identificador', value: 'identificador', width: '220px' },
		{ text: 'Motivo', value: 'motivo' },
	]

	mostrar(importacaoId: string, origem: string): void {
		this.importacaoId = importacaoId
		this.origem = origem
		this.resumo = resumoVazio()
		this.pagina = 1
		this.mostra = true
		this.buscar()
	}

	async buscar(): Promise<void> {
		const busca = ++this.buscaAtual
		this.buscando = true
		this.falhouAoBuscar = false
		try {
			const page = await this.findImportacaoUseCase.findItens({
				importacaoId: this.importacaoId,
				page: 0,
				size: 1,
			})
			if (busca !== this.buscaAtual) return
			const mensagem: string | null = page.content.length ? page.content[0].mensagemDeErro : null
			this.resumo = interpretarXmlsNaoGerados(mensagem)
		} catch (error: any) {
			if (busca !== this.buscaAtual) return
			this.falhouAoBuscar = true
			AlertModule.setError(error)
		} finally {
			if (busca === this.buscaAtual) this.buscando = false
		}
	}

	async baixarXmlsGerados(): Promise<void> {
		if (this.baixando) return
		this.baixando = true
		try {
			await this.baixar(this.importacaoId)
		} finally {
			this.baixando = false
		}
	}

	get nomeDaLoja(): string {
		const marcador = ' - Loja: '
		const posicao = this.origem.indexOf(marcador)
		return posicao < 0 ? '' : this.origem.substring(posicao + marcador.length)
	}

	get quantidadeGerada(): number | null {
		const { quantidadeComFalha, quantidadeTotal } = this.resumo
		if (quantidadeComFalha === null || quantidadeTotal === null) return null
		return Math.max(quantidadeTotal - quantidadeComFalha, 0)
	}

	get titulo(): string {
		const { quantidadeComFalha, quantidadeTotal } = this.resumo
		if (quantidadeComFalha === null || quantidadeTotal === null) return 'Alguns XMLs não puderam ser gerados.'
		if (quantidadeComFalha === quantidadeTotal) {
			return quantidadeTotal === 1
				? 'O XML não pôde ser gerado.'
				: `Nenhum dos ${this.formatar(quantidadeTotal)} XMLs pôde ser gerado.`
		}
		return quantidadeComFalha === 1
			? `1 de ${this.formatar(quantidadeTotal)} XMLs não pôde ser gerado.`
			: `${this.formatar(quantidadeComFalha)} de ${this.formatar(quantidadeTotal)} XMLs não puderam ser gerados.`
	}

	// O total da mensagem conta também nota inutilizada, que não tem XML; por isso a explicação
	// não afirma quantos arquivos o ZIP tem.
	get explicacao(): string {
		if (this.quantidadeGerada === 0) return 'O arquivo não tem XMLs. Confira abaixo o motivo de cada documento.'
		return 'Os demais XMLs estão no arquivo, que pode ser baixado normalmente.'
	}

	get linhas(): LinhaDeXmlNaoGerado[] {
		return this.resumo.documentos.map((documento, indice) => ({ ...documento, indice }))
	}

	get mostrarAvisoDeCorte(): boolean {
		return this.resumo.listaCortada && this.resumo.documentos.length > 0
	}

	get podeBaixar(): boolean {
		return !this.buscando && !this.falhouAoBuscar && this.quantidadeGerada !== 0
	}

	formatar(quantidade: number): string {
		return quantidade.toLocaleString('pt-BR')
	}
}
